// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"67":"50896c51f7b39f052934","94":"b852e88175b13c3ceba1","236":"d360b12fabe7e6f8d863"}[chunkId] + ".js";
};